import { Flex, Portal, Text } from '@chakra-ui/react';
import {
  currentWallet,
  getAddEthereumChainParameter,
  useDesiredChain,
  walletConfigs,
} from '@cronos-app/wallet';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';
import type { FC } from 'react';
import { create } from 'zustand';

import { CloseButton } from '../CloseButton';
import { DialogOrDrawer } from '../DialogOrDrawer';
import { WalletCard } from './WalletCard';

interface UseWalletModal {
  isOpen: boolean;
  closeModal: () => void;
  openModal: () => void;
}

export const useWalletModal = create<UseWalletModal>((set) => ({
  isOpen: false,
  closeModal: () => {
    set({ isOpen: false });
  },
  openModal: () => {
    set({ isOpen: true });
  },
}));

export const WalletModal: FC<unknown> = () => {
  const isOpen = useWalletModal((s) => s.isOpen);
  const closeModal = useWalletModal((s) => s.closeModal);
  const chainLayer = useGlobalChainLayer();
  const chainId = useDesiredChain(chainLayer);

  return (
    <DialogOrDrawer.Root
      open={isOpen}
      placement={{
        desktopDown: 'bottom',
        desktop: 'top',
      }}
      onOpenChange={(state) => !state.open && closeModal()}
    >
      <DialogOrDrawer.Backdrop />
      <Portal>
        <DialogOrDrawer.Positioner>
          <DialogOrDrawer.DragContent
            minH={{
              desktopDown: '70vh',
            }}
          >
            <DialogOrDrawer.Header>Log in / Sign up</DialogOrDrawer.Header>
            <DialogOrDrawer.CloseTrigger asChild>
              <CloseButton />
            </DialogOrDrawer.CloseTrigger>
            <DialogOrDrawer.Body pb={6}>
              <Text textStyle="body2" textAlign="center">
                Log in with your wallet! (◍•ᴗ•◍)✧*。
              </Text>
              <Flex direction="column" gap="16px" mt="24px">
                {walletConfigs.map((v) => (
                  <WalletCard
                    key={v.name}
                    onClick={async () => {
                      closeModal();
                      await currentWallet.connectAsCurrentWallet(
                        v.name,
                        getAddEthereumChainParameter(chainId),
                      );
                    }}
                    walletConfig={v}
                  />
                ))}
              </Flex>
            </DialogOrDrawer.Body>
          </DialogOrDrawer.DragContent>
        </DialogOrDrawer.Positioner>
      </Portal>
    </DialogOrDrawer.Root>
  );
};
